import * as React from 'react';
import { Route } from 'react-router-dom';
import RoadsList from '@features/road-network-editor/RoadNetworkManager/Roads/RoadsList';
import RoadEdit from '@features/road-network-editor/RoadNetworkManager/Roads/RoadEdit';
import Road from '@features/road-network-editor/RoadNetworkManager/Roads/Road';
import RoadSegments from '@features/road-network-editor/RoadNetworkManager/RoadSegments/RoadSegments';
import RoadSegmentEdit from '@features/road-network-editor/RoadNetworkManager/RoadSegments/RoadSegmentEdit';
import GroupSelection from '../../widgets/group-selection/GroupSelection';
import BreadcrumbedComponent from '@components/BreadcrumbedComponent/BreadcrumbedComponent';
import RouteChecker from '@features/road-network-editor/RoadNetworkManager/RoadRouteChecker/RouteChecker';
import MapRoadsFilter from '@features/road-network-editor/RoadNetworkManager/MapFilters/MapRoadsFilter';
import LazyLoadingWrapper from '@components/LazyLoadingWrapper/LazyLoadingWrapper';
import LayersTimeSelectors from '@features/map-layers-list/time-selector/LayersTimeSelectors';
import NavigateWithSearch from '@components/NavigateWithSearch/NavigateWithSearch';
import { RoadInfrastructureEntityName } from '@api/types/types';
import { EntityServiceName } from '@api/enums/enums';
import DistrictsList from '@features/districts/districts-list/ui/DistrictsList';
import DistrictEdit from '@features/districts/district-creation/ui/DistrictEdit';
import LayersListWrapper from '@features/map-layers-list/layers-list/LayersListWrapper';

const RoadNetworkEditor = React.lazy(() => import('@pages/ProjectModes/RoadNetworkEditorModePage'));

export const useRoadsRoutes = () => {
    return (
        <Route path="network" element={<LazyLoadingWrapper element={<RoadNetworkEditor />} />}>
            <Route index element={<NavigateWithSearch to="roads" replace />} />
            <Route
                element={<BreadcrumbedComponent />}
                handle={{ crumb: (data: any) => ({ name: 'Roads', ...data }) }}
            >
                <Route path="roads">
                    <Route index element={<RoadsList />} />
                    <Route path="new" element={<RoadEdit />} />
                    <Route
                        path=":roadId"
                        element={<Road />}
                        loader={({ params }) => params}
                        handle={{
                            crumb: ({ roadId }) => ({
                                id: roadId,
                                entityName: RoadInfrastructureEntityName.Road,
                                testId: 'roadIdBreadcrumb',
                            }),
                        }}
                    >
                        <Route index element={<RoadSegments />} />
                        <Route path="edit" element={<RoadEdit />} />
                        <Route path=":new" element={<RoadSegmentEdit />} />
                        <Route
                            path=":roadSegmentId/edit"
                            element={<RoadSegmentEdit />}
                            loader={({ params }) => params}
                            handle={{
                                crumb: ({ roadSegmentId }) => ({
                                    id: roadSegmentId,
                                    entityName: RoadInfrastructureEntityName.RoadSegment,
                                }),
                            }}
                        />
                    </Route>
                </Route>
            </Route>
            <Route
                path="districts"
                element={<BreadcrumbedComponent />}
                handle={{ crumb: (data: any) => ({ name: 'Districts', ...data }) }}
            >
                <Route index element={<DistrictsList />} />
                <Route
                    path="new"
                    element={<DistrictEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ districtId }) => ({ id: districtId }) }}
                />
                <Route
                    path=":districtId/edit"
                    element={<DistrictEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ districtId }) => ({ id: districtId }) }}
                />
            </Route>
            <Route
                path="layers"
                element={
                    <LayersListWrapper>
                        <LayersTimeSelectors />
                    </LayersListWrapper>
                }
            />
            <Route
                path="groupselection"
                element={
                    <GroupSelection
                        entityName={'replancity_RoadInfrastructureUpdateSegment'}
                        sourceEntityName={RoadInfrastructureEntityName.RoadSegment}
                        groupUpdateTaskArgument="roadInfrastructureUpdateTask"
                    />
                }
            />
            <Route
                path="checkroute"
                element={<RouteChecker entityServiceName={EntityServiceName.ROAD_INFRASTRUCTURE} />}
            />
            <Route path="mapfilters" element={<MapRoadsFilter />} />
            {/*<Route*/}
            {/*    path="toll-pairs"*/}
            {/*    element={<BreadcrumbedComponent/>}*/}
            {/*    handle={{crumb: (data: any) => ({name: 'Toll pairs', ...data})}}*/}
            {/*>*/}
            {/*    <Route index element={<TollPairsList/>}/>*/}
            {/*    <Route*/}
            {/*        path=":tollPairId"*/}
            {/*        element={<TollPairEdit/>}*/}
            {/*        loader={({params}) => params}*/}
            {/*        handle={{crumb: ({tollPairId}) => ({id: tollPairId})}}*/}
            {/*    />*/}
            {/*</Route>*/}
            {/*<Route*/}
            {/*    path="toll-zones"*/}
            {/*    element={<BreadcrumbedComponent/>}*/}
            {/*    handle={{crumb: (data: any) => ({name: 'Toll zones', ...data})}}*/}
            {/*>*/}
            {/*    <Route index element={<TollZonesList/>}/>*/}
            {/*    <Route*/}
            {/*        path=":tollZoneId"*/}
            {/*        element={<TollZoneEdit/>}*/}
            {/*        loader={({params}) => params}*/}
            {/*        handle={{crumb: ({tollZoneId}) => ({id: tollZoneId})}}*/}
            {/*    />*/}
            {/*</Route>*/}
        </Route>
    );
};
